import React from "react";
import {
  CreateProps,
  maxValue,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useRedirect,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import { GetParam } from "utils/tools";
import CustomCreateToolbar from "../../components/CustomCreateToolbar";
import SanitizedGrid from "../../components/SanitizedGrid";
import CustomDateRangeInput from "../../components/CustomDateRangeInput";
import CreateWrapper from "../../components/CreateWrapper";

const StudentSubsidyCreate = (props: CreateProps) => {
  const param = GetParam();
  const redirect = useRedirect();

  let breadcrumbValue = [{ link: "", title: "", params: "" }];

  if (param.get("parentId")) {
    breadcrumbValue = [
      {
        title: "Parents",
        link: `/parents/${param.get("parentId")}/show`,
        params: "",
      },
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Payment Setting",
        link: `/students/${param.get("studentId")}/show/6`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Create",
        link: "",
        params: "",
      },
    ];
  } else {
    breadcrumbValue = [
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: "",
      },
      {
        title: "Payment Setting",
        link: `/students/${param.get("studentId")}/show/6`,
        params: "",
      },
      {
        title: "Create",
        link: "",
        params: "",
      },
    ];
  }

  const breadcrumb = breadcrumbValue;

  const CustomRedirect = ({ data }: any) => {
    redirect(`/students/${data.studentId}/show/6`);
    window.location.reload();
  };

  const transform = async (data: any) => {
    data.studentIdentifier = data.studentId;

    // Set value for studentIdentifierType field.
    // This will be used for StudentIdentifierType in the API.
    // Means, It will get the student data by StudentId.
    data.studentIdentifierType = "studentId";

    return data;
  };

  return (
    <CreateWrapper
      breadcrumb={breadcrumb}
      headerTitle="Create Student Subsidy"
      transform={transform}
      onSuccess={CustomRedirect}
      {...props}
    >
      <SimpleForm toolbar={<CustomCreateToolbar />}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Student</Typography>
          </Grid>
          <Grid item xs={3}>
            <ReferenceInput
              label="Select Student"
              source="studentId"
              reference="students"
              disabled
            >
              <SelectInput
                optionText={(choice: any) =>
                  `${choice.firstName} ${choice.lastName}`
                }
              />
            </ReferenceInput>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6">Subsidy Details</Typography>
          </Grid>

          <Grid item xs={12}>
            <CustomDateRangeInput
              fromSource="periodStartDate"
              toSource="periodEndDate"
              fromLabel="Period Start Date"
              toLabel="Period End Date"
              gridItemWidth={2}
            />
          </Grid>

          <Grid item xs={4}>
            <NumberInput
              source="subsidyPercentage"
              label="Subsidy Percentage (%)"
              validate={[required(), minValue(0), maxValue(100)]}
            />
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <TextInput
              multiline={true}
              label="Remark"
              source="remark"
            />
          </Grid>
        </SanitizedGrid>
      </SimpleForm>
    </CreateWrapper>
  );
};

export default StudentSubsidyCreate;
